import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AuthServiceService } from 'src/app/data/fireservices/auth-service.service';
import { FirestoreService } from 'src/app/data/services/firestore.service';

import { colombia } from '../../data/colombia';  // ver nota sobre el import

@Component({
  selector: 'app-actualizar-ubicacion',
  templateUrl: './actualizar-ubicacion.component.html',
  styleUrls: ['./actualizar-ubicacion.component.scss'],
})
export class ActualizarUbicacionComponent implements OnInit {

  // Lista plana: cada municipio con su departamento
  municipiosPlanos: { municipio: string, departamento: string }[] = [];
  resultados: { municipio: string, departamento: string }[] = [];

  busqueda = '';
  seleccion: { municipio: string, departamento: string } | null = null;
  guardando = false;

  constructor(
    private modalController: ModalController,
    public auth: AuthServiceService,
    private firestoreService: FirestoreService,
  ) { }

  ngOnInit() {
    this.construirListaPlana();
  }

  construirListaPlana() {
    (colombia as any[]).forEach(dep => {
      dep.ciudades.forEach((ciudad: string) => {
        this.municipiosPlanos.push({
          municipio: ciudad,
          departamento: dep.departamento
        });
      });
    });
  }

  // Filtra en vivo mientras el usuario escribe
  buscar(event: any) {
    const texto = (event.target.value || '').toLowerCase().trim();
    this.busqueda = texto;

    if (texto.length < 2) {
      this.resultados = [];
      return;
    }

    // Normaliza para ignorar tildes
    const normalizar = (s: string) => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    const textoNorm = normalizar(texto);

    this.resultados = this.municipiosPlanos
      .filter(m => normalizar(m.municipio).includes(textoNorm))
      .slice(0, 50);   // limitar para no renderizar miles
  }

  seleccionar(item: { municipio: string, departamento: string }) {
    this.seleccion = item;
    this.busqueda = item.municipio;
    this.resultados = [];   // cerrar la lista al elegir
  }

  async guardar() {
    if (!this.seleccion) { return; }
    this.guardando = true;
    try {
      await this.firestoreService.actualizarDato('users', this.auth.userData.uid, {
        departamento: this.seleccion.departamento,
        ciudad: this.seleccion.municipio
      });
      this.modalController.dismiss({ actualizado: true });
    } catch (e) {
      console.error('Error al guardar ubicación:', e);
      this.guardando = false;
      alert('No se pudo guardar la ubicación. Verifica tu conexión e intenta de nuevo.');
    }
  }
}